// extracted by mini-css-extract-plugin
module.exports = {"SkipTo":"SkipToContent_SkipTo__TTfqd"};